module.exports = __webpack_public_path__ + "static/media/BLUSH_3021.40921362.jpg";